"use client";

import { SupportButtonNotFound } from "./support-button-not-found";
import { Button } from "@/components/catalyst/button";
import { useTranslations } from "next-intl";

interface StatusCodeErrorProps {
  statusCode?: string;
  actionButton: React.ReactNode;
  supportButton: React.ReactNode;
}

export function StatusCodeError({
  statusCode,
  actionButton,
  supportButton,
}: StatusCodeErrorProps) {
  const t = useTranslations("Error");
  return (
    <GenericError
      statusCode={statusCode}
      title={t("title")}
      description={t("description")}
      actionButton={actionButton}
      supportButton={supportButton}
    />
  );
}

export function ErrorButtonReset({ reset }: { reset: () => void }) {
  const t = useTranslations("Error");

  return (
    <Button color="purple" onClick={reset}>
      {t("tryAgain")}
    </Button>
  );
}

export function ErrorButtonGoHome() {
  const t = useTranslations("Error");

  return (
    <Button color="purple" href="/">
      {t("goHome")}
    </Button>
  );
}

export function NotFoundError() {
  const t = useTranslations("NotFound");
  return (
    <GenericError
      statusCode="404"
      title={t("title")}
      description={t("description")}
      actionButton={<ErrorButtonGoHome />}
      supportButton={<SupportButtonNotFound />}
    />
  );
}

interface GenericErrorProps {
  statusCode?: string;
  title: string;
  description: string;
  actionButton: React.ReactNode;
  supportButton: React.ReactNode;
}
function GenericError({
  statusCode,
  title,
  description,
  actionButton,
  supportButton,
}: GenericErrorProps) {
  return (
    <div className="flex min-h-full flex-col">
      <main className="grid flex-1 place-items-center bg-white px-6 py-24 sm:py-32 lg:px-8 dark:bg-gray-900">
        <div className="text-center">
          {statusCode && (
            <p className="text-4xl font-semibold text-purple-600 dark:text-purple-400">
              {statusCode}
            </p>
          )}
          <h1 className="mt-4 text-5xl font-semibold tracking-tight text-balance text-gray-900 sm:text-7xl dark:text-white">
            {title}
          </h1>
          <p className="mt-6 text-lg font-medium text-pretty text-gray-500 sm:text-xl/8 dark:text-gray-400">
            {description}
          </p>
          <div className="mt-10 flex items-center justify-center gap-x-6">
            {actionButton}

            {supportButton}
          </div>
        </div>
      </main>
    </div>
  );
}
